var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168.81 188.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 7px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.25,42.17L93.47,5.93c-5.61-3.24-12.52-3.24-18.12,0L12.56,42.17c-5.61,3.24-9.06,9.22-9.06,15.7v72.49c0,6.48,3.45,12.46,9.06,15.7l62.78,36.25c5.61,3.24,12.52,3.24,18.12,0l62.78-36.25c5.61-3.24,9.06-9.22,9.06-15.7V57.87c0-6.48-3.45-12.46-9.06-15.7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD20);
export default __webpack_public_path__ + "static/media/D20.9a9ea26addb67aa38424178e18e74374.svg";
export { ForwardRef as ReactComponent };